import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CircleNotch, Star, Gift } from "@phosphor-icons/react";
import api from "../lib/api";
import { WheelModal } from "../components/WheelModal";

export default function WrapWheelPage() {
  const [rewards, setRewards] = useState(null);
  const [points, setPoints] = useState(null);
  const [open, setOpen] = useState(true);

  const load = useCallback(() => {
    api.get("/shift-notes/rewards/me").then((r) => setRewards(r.data)).catch(() => setRewards({ enabled: false }));
    api.get("/points/me").then((r) => setPoints(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!rewards) {
    return <div className="flex justify-center py-24" data-testid="wrap-wheel-loading"><CircleNotch size={28} className="animate-spin text-primary" /></div>;
  }
  if (!rewards.enabled || !(rewards.prizes || []).length) {
    return <div className="py-24 text-center text-sm text-stone-500" data-testid="wrap-wheel-paused">The prize wheel is paused right now — check back soon.</div>;
  }

  const spins = rewards.spins_available || 0;

  return (
    <div className="mx-auto max-w-3xl px-4 py-8" data-testid="wrap-wheel-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-heading text-3xl tracking-tight text-[#4A235A]">Prize wheel</h1>
          <p className="mt-1 text-sm text-stone-500">Every on-time wrap-up earns a spin. A perfect week earns a bonus spin.</p>
        </div>
        <Link to="/swag-shop" className="inline-flex items-center gap-2 rounded-full border border-[#4A235A]/30 px-4 py-2 text-sm font-semibold text-[#4A235A] transition-colors hover:bg-[#4A235A] hover:text-white" data-testid="wheel-to-shop-link">
          <Star size={16} weight="fill" /> Swag Shop{points ? ` · ${points.balance || 0} pts` : ""}
        </Link>
      </div>

      <div className="mt-4 flex items-center gap-4 rounded-xl border border-stone-200 bg-white px-5 py-4 shadow-sm" data-testid="wheel-spin-count">
        <Gift size={32} className="text-[#4A235A]" />
        <div>
          <p className="font-heading text-3xl font-semibold leading-none text-[#4A235A]" data-testid="spins-available">{spins}</p>
          <p className="mt-0.5 text-[11px] font-semibold uppercase tracking-wider text-stone-500">spins available</p>
        </div>
        {!open && spins > 0 && (
          <button onClick={() => setOpen(true)}
            className="ml-auto rounded-full bg-[#4A235A] px-6 py-2 text-sm font-semibold text-white transition-transform hover:scale-105"
            data-testid="wheel-open-btn">
            Spin the wheel
          </button>
        )}
        {!open && spins === 0 && (
          <p className="ml-auto text-xs text-stone-400" data-testid="wheel-none-left">No spins left — wrap up a shift on time to earn the next one.</p>
        )}
      </div>

      {(rewards.wins || []).length > 0 && (
        <div className="mt-4 rounded-xl border border-stone-200 bg-white p-5 shadow-sm" data-testid="wheel-my-wins">
          <p className="text-xs font-semibold uppercase tracking-wider text-stone-400">Your wins</p>
          <ul className="mt-2 space-y-1">
            {[...rewards.wins].reverse().map((w, i) => (
              <li key={i} className="flex justify-between text-sm text-stone-600">
                <span>{w.prize}{w.value ? <span className="ml-1 text-xs text-stone-400">({w.value} value)</span> : null}</span>
                <span className="text-xs text-stone-400">{String(w.at || "").slice(0, 10)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {open && <WheelModal prizes={rewards.prizes} onDone={() => { setOpen(false); load(); }} />}
    </div>
  );
}
